import React from 'react';
import { useSelector } from 'react-redux';
import { useWindowSize } from 'modules/core';
import { getAccountType } from 'modules/accounts';
import { getTalent, Talent } from 'modules/talents';
import { ACCOUNT_TYPES } from 'modules/accounts/const';
import {
  getIsAuthenticated,
  getPasswordResetRequired,
  getPendingVerification,
} from '../redux';
import { useLocation, Navigate } from 'react-router-dom';

export default function AuthRoute({ children }) {
  const authenticated = useSelector(getIsAuthenticated);
  const location = useLocation();
  const accountType = useSelector(getAccountType);
  const talent = useSelector(getTalent);
  const pendingVerification = useSelector(getPendingVerification);
  const passwordResetRequired = useSelector(getPasswordResetRequired);
  const { desktopWidth } = useWindowSize();

  if (authenticated) {
    const redirectPath =
      accountType === ACCOUNT_TYPES.TALENT && desktopWidth // TODO : remove desktopWidth when talents edit profile page is responsive
        ? Talent.getLoginRedirectPath(talent)
        : '/';
    return <Navigate replace to={redirectPath} />;
  }

  if (
    !passwordResetRequired &&
    location.pathname === '/auth/complete-new-password'
  ) {
    return <Navigate replace to="/login" />;
  }

  if (!pendingVerification && location.pathname === '/welcome') {
    return <Navigate replace to="/login" />;
  }

  return children;
}
